
import React from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ 
  isOpen, 
  onClick 
}) => {
  return (
    <Button 
      variant="ghost" 
      size="icon" 
      onClick={onClick}
      aria-label={isOpen ? "Close Menu" : "Open Menu"}
      className="relative focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Menu className={`h-5 w-5 transition-opacity ${isOpen ? 'opacity-0' : 'opacity-100'}`} />
      <X className={`absolute h-5 w-5 transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0'}`} />
    </Button>
  );
};
